import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { findIcon } from '../../../common/constants';

interface GreenCheckMarkProps {
    key?: number;
    name: string;
}

const GreenCheckMark = ({ name }: GreenCheckMarkProps) => {
    return (
        <h4>
            <FontAwesomeIcon
                icon={findIcon('fad', 'check')}
                className="font-green"
            />{' '}
            {name}
        </h4>
    );
};

export default GreenCheckMark;
